import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, Teleport as _Teleport } from "vue"
import _imports_0 from '../../assets/icons/calendar.png'
import _imports_1 from '../../assets/icons/add.png'


const _hoisted_1 = { class: "main-container content-start items-start mt-8" }
const _hoisted_2 = { class: "flex col-start-1 col-end-13 justify-between !items-center w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "ac-subtitle !text-3xl my-0" }, "Etkinlik Kategorileri", -1)
const _hoisted_4 = { class: "action-row col-start-1 col-end-13 flex items-center justify-end" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-4",
  width: "20",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-4",
  width: "20",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_7 = { class: "alt-table col-start-1 col-end-13 w-full mt-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Başlık"),
    /*#__PURE__*/_createElementVNode("th", null, "İşlemler")
  ])
], -1)
const _hoisted_9 = { class: "text-overflow w-24" }
const _hoisted_10 = { class: "text-overflow" }
const _hoisted_11 = { class: "flex" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

import acMediumModal from "../reusable/teleports/acMediumModal.vue"
import addMeta from "../reusable/teleports/addMeta"
import { ref, onBeforeMount } from "vue"
import firebaseOperations from "../../mixins/firebaseOperations"
import { modalClosed } from "../../mixins/visualFormatters"
import { updateMeta, getMetas, deleteMeta } from "../../mixins/modularFirebaseOperations"
import { useRouter } from "vue-router"
import type { EventCategory } from "@/types/events"


export default /*#__PURE__*/_defineComponent({
  __name: 'eventCategories',
  setup(__props) {

const router = useRouter()
const addedMeta = ref<string>("")
const existingMeta = ref<EventCategory | undefined>(undefined)

const eventCats = ref<EventCategory[]>([])

const isLoadingEventCats = ref(false)

const handleAddedData = function(meta) {
    firebaseOperations.methods.postData(meta, "/metas/calendar/eventCats")
    eventCats.value.push(meta)
    addedMeta.value = ""
    modalClosed()
}

const goBackToCalendar = function(){
    router.push({path: "/calendar"})
}

const handleUpdatedData =  async function(newdata){
    await updateMeta("metas/calendar/eventCats", existingMeta.value.id, newdata)

    // find the updated meta in the array and update it
    const index = eventCats.value.findIndex((meta) => meta.id === existingMeta.value.id)
    eventCats.value[index].name = newdata.name
    eventCats.value[index].color = newdata.color
    existingMeta.value = undefined
    addedMeta.value = ""
    modalClosed()

}

onBeforeMount(() => {
    getMetas("metas/calendar/eventCats", eventCats.value, isLoadingEventCats)
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          onClick: goBackToCalendar,
          class: "ac-add-button mr-4"
        }, [
          _hoisted_5,
          _createTextVNode(" Takvime Dön ")
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (addedMeta.value = 'eventCats')),
          class: "ac-add-button"
        }, [
          _hoisted_6,
          _createTextVNode(" Yeni Etkinlik Kategorisi Ekle ")
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_7, [
      _hoisted_8,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventCats.value, (cat) => {
        return (_openBlock(), _createElementBlock("tr", {
          class: "hover:bg-gray-100 relative cursor-pointer",
          key: cat.id
        }, [
          _createElementVNode("td", _hoisted_9, [
            _createElementVNode("div", {
              class: "w-6 h-6 rounded-full",
              style: _normalizeStyle({backgroundColor: cat.color})
            }, null, 4)
          ]),
          _createElementVNode("td", _hoisted_10, _toDisplayString(cat.name), 1),
          _createElementVNode("td", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              class: "table-button",
              onClick: ($event: any) => (_unref(deleteMeta)('metas/calendar/eventCats', cat.id, eventCats.value))
            }, " Sil ", 8, _hoisted_12),
            _createElementVNode("button", {
              type: "button",
              class: "table-button",
              onClick: ($event: any) => {addedMeta.value='eventCats'; existingMeta.value=cat}
            }, " Düzenle ", 8, _hoisted_13)
          ])
        ]))
      }), 128))
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (addedMeta.value)
            ? (_openBlock(), _createBlock(acMediumModal, {
                key: 0,
                class: "lg:!top-44 overflow-y-scroll",
                onModalClosed: _cache[3] || (_cache[3] = ($event: any) => (addedMeta.value = '')),
                height: "85vh",
                width: "70vw",
                title: "Yeni Ekle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(addMeta), {
                    onAddNewMeta: _cache[1] || (_cache[1] = ($event: any) => (handleAddedData($event))),
                    onUpdatedMeta: _cache[2] || (_cache[2] = ($event: any) => (handleUpdatedData($event))),
                    "existing-meta": existingMeta.value,
                    meta: addedMeta.value
                  }, null, 8, ["existing-meta", "meta"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})